<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout wrap justify-space-between pb-2 pt-2 class="text-sm-left">
    <v-flex xs5>
      <h2 style="margin-bottom: 30px;">Grundpreis Liste</h2>
      <v-data-table class="base-price-table-container"
                    :items="room.basePrices" :items-per-page="200"
                    hide-default-footer
                    hide-default-headers>
        <template v-slot:item="props">
          <tr>
            <td>
              <v-edit-dialog
                :return-value.sync="props.item.name">
                <v-tooltip bottom style="min-width: 40px;min-height: 20px;">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">{{ props.item.name }}</div>
                  </template>
                  <span>Bearbeiten</span>
                </v-tooltip>
                <v-text-field
                  slot="input"
                  v-model="props.item.name"
                  :rules="rules"
                  label="Name"
                  single-line
                  required
                />
              </v-edit-dialog>
            </td>
            <td>
              <v-edit-dialog
                :return-value.sync="props.item.price">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">{{ props.item.price }} €</div>
                  </template>
                  <span>Bearbeiten</span>
                </v-tooltip>
                <v-text-field
                  slot="input"
                  v-model="props.item.price"
                  :rules="rules"
                  label="Preis"
                  single-line
                  type="number"
                  required
                ></v-text-field>
              </v-edit-dialog>
            </td>
            <td>
              <v-flex xs12 v-for="(interval, index) in props.item.seasonIntervals" :key="index"
                      style="min-width: 215px;">
                <v-edit-dialog style="display: inline-block; width: auto; height: auto;"
                               :return-value.sync="interval.seasonFrom" ref="seasonFrom">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" style="display: inline-block;">{{interval.seasonFrom | date}}</div>
                    </template>
                    <span>Bearbeiten</span>
                  </v-tooltip>
                  <v-text-field
                    slot="input"
                    v-model="interval.seasonFrom"
                    :rules="rules"
                    label="Saison von"
                    single-line
                    required
                  ></v-text-field>
                </v-edit-dialog>
                -
                <v-edit-dialog style="display: inline-block; width: auto; height: auto;"
                               :return-value.sync="interval.seasonTo" ref="seasonTo">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" style="display: inline-block;">{{interval.seasonTo | date}}</div>
                    </template>
                    <span>Bearbeiten</span>
                  </v-tooltip>
                  <v-text-field
                    slot="input"
                    v-model="interval.seasonTo"
                    :rules="rules"
                    label="Saison bis"
                    single-line
                    required
                  ></v-text-field>
                </v-edit-dialog>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon ripple style="margin-top: -3px;" v-on="on" small
                           @click="deleteInterval(index, props.item)">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Zeitintervall löschen</span>
                </v-tooltip>
              </v-flex>
            </td>
            <td class="text-sm-right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon ripple v-on="on"
                         @click="deleteFromRules(props.item)">
                    <v-icon color="red">delete</v-icon>
                  </v-btn>
                </template>
                <span>Grundpreis löschen</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs5 offset-xs2>
      <h2 style="margin-bottom: 30px;">Grundpreis hinzufügen</h2>
      <v-form v-model="form" ref="addBasePriceRule" lazy-validation>
        <v-layout wrap row>
          <v-flex xs12>
            <v-alert
              :value="true"
              color="info"
              icon="info"
              outlined>
              Grundpreis wird nach Preisen zusammengeschlossen und nicht nach Saisonnamen.
            </v-alert>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="filter.selected"
              :items="filter.week"
              item-text="label"
              item-value="value"
              open-on-clear clearable
              @change="clearFilter()"
              attach
              chips
              label="Wochentage"
              multiple
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 sm5>
                <v-text-field
                  v-model="rule.name"
                  :label="$t('hotel.kognitiv.seasonName')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 sm5>
                <v-text-field
                  v-model="rule.price"
                  :label="$t('hotel.kognitiv.additionalGuestPrice')"
                  required
                  :rules="rules"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-menu :close-on-content-click="false"
                    v-model="datepicker.seasonFrom"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="rule.seasonFrom"
                  label="Von"
                  prepend-icon="event"
                  required
                  :rules="rules"
                  readonly></v-text-field>
              </template>
              <v-date-picker v-model="rule.seasonFrom" no-title
                             first-day-of-week="1" locale="de"
                             scrollable :allowed-dates="allowedDates"
                             @input="datepicker.seasonFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-menu :close-on-content-click="false"
                    v-model="datepicker.seasonTo"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
               <v-text-field
                 v-on="on"
                v-model="rule.seasonTo"
                label="Bis"
                prepend-icon="event"
                required
                :rules="rules"
                readonly></v-text-field>
              </template>
              <v-date-picker v-model="rule.seasonTo" no-title
                             first-day-of-week="1" locale="de"
                             :min="rule.seasonFrom" :allowed-dates="allowedDates"
                             scrollable @input="datepicker.seasonTo = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 offset-xs1>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon text v-on="on"
                       @click="addBasePriceRule()" color="primary">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Grundpreis hinzufügen</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12 mb-2 style="color: red; text-align: right;" v-if="error">
            Überschneidung mit bereits definierte Saisons gefunden!
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout class="add-base-price-container" wrap v-if="getOtherBasePrices().length > 0">
        <v-flex xs12>
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header><h3>Grundpreis von andere Zimmer übernehmen</h3></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list two-line dense>
                  <div v-for="room in getOtherBasePrices()" :key="'baseRoomPrice_'+room.externalId">
                    <v-subheader><h3>{{ room.name }} ({{ room.externalId }})</h3></v-subheader>
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-icon color="primary">label</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>Zimmer: {{ room.name }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-expansion-panels accordion>
                            <v-expansion-panel>
                              <v-expansion-panel-header style="min-height: 25px; padding: 0;">Grundpreise</v-expansion-panel-header>
                              <v-expansion-panel-content>

                                <v-data-table class="base-price-table-container"
                                              :items="room.basePrices"
                                              hide-default-footer
                                              hide-default-headers>
                                  <template v-slot:item="props">
                                    <tr>
                                      <td class="text-sm-left">
                                        <v-flex sx12>{{ props.item.price }} €</v-flex>
                                      </td>
                                      <td class="text-sm-left">
                                        <v-layout wrap>
                                          <v-flex xs12 v-for="(interval, index) in props.item.seasonIntervals" :key="index">
                                            {{interval.seasonFrom | date}} - {{interval.seasonTo | date}}
                                          </v-flex>
                                        </v-layout>
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn text color="primary" icon ripple v-on="on"
                                   @click="addBasePrices(room)">
                              <v-icon color="primary">add</v-icon>
                            </v-btn>
                          </template>
                          <span>Grundpreise übernehmen</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </v-list>
              </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'BasePriceRule',
    props: {
      rooms: undefined,
      room: undefined
    },
    data() {
      return {
        form: undefined,
        rule: {
          name: undefined,
          price: undefined,
          seasonFrom: undefined,
          seasonTo: undefined
        },
        datepicker: {
          seasonFrom: false,
          seasonTo: false
        },
        filter: {
          week: [
            { label: 'Alle', value: -1 },
            { label: 'Montag', value: 0 },
            { label: 'Dienstag', value: 1 },
            { label: 'Mittwoch', value: 2 },
            { label: 'Donnerstag', value: 3 },
            { label: 'Freitag', value: 4 },
            { label: 'Samstag', value: 5 },
            { label: 'Sonntag', value: 6 },
          ],
          selected: [
            -1
          ],
          changed: false
        },
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        selected: {
          basePrice: undefined
        },
        error: false
      };
    },
    methods: {
      getNewDates() {
        const dates = [];
        if (this.rule.seasonFrom !== undefined && this.rule.seasonTo !== undefined) {
          let date = this.$moment(this.rule.seasonFrom);
          const last = this.$moment(this.rule.seasonTo);
          do {
            if (this.filter.selected.length === 0 || this.filter.selected[0] === -1) {
              dates.push(this.$moment(date.format('YYYY-MM-DD')));
            } else if (this.containsWeekDay(date)) {
              dates.push(this.$moment(date.format('YYYY-MM-DD')));
            }
            date = date.add(1, 'days');
          } while (date.isSameOrBefore(last));
        }
        return dates;
      },
      getUsedDates() {
        const dates = [];
        for (let i = 0; i < this.room.basePrices.length; i += 1) {
          const basePrice = this.room.basePrices[i];
          for (let j = 0; j < basePrice.seasonIntervals.length; j += 1) {
            const interval = basePrice.seasonIntervals[j];
            let date = this.$moment(interval.seasonFrom);
            const last = this.$moment(interval.seasonTo);
            do {
              dates.push(this.$moment(date.format('YYYY-MM-DD')));
              date = date.add(1, 'days');
            } while (date.isSameOrBefore(last));
          }
        }
        return dates;
      },
      hasUsedDates() {
        const newDates = this.getNewDates();
        const oldDates = this.getUsedDates();
        for (let i = 0; i < newDates.length; i += 1) {
          const newDate = newDates[i];
          for (let j = 0; j < oldDates.length; j += 1) {
            const oldDate = oldDates[j];
            if (newDate.isSame(oldDate)) {
              return true;
            }
          }
        }
        return false;
      },
      clearFilter() {
        if (this.filter.changed) {
          const index = this.filter.selected.indexOf(-1);
          if (index > -1) {
            this.filter.selected = [-1];
            this.filter.changed = false;
          }
        } else {
          const index = this.filter.selected.indexOf(-1);
          if (index > -1) {
            this.filter.selected.splice(index, 1);
            this.filter.changed = true;
          }
        }
      },
      addBasePriceRule() {
        if (this.$refs.addBasePriceRule.validate()) {
          if (!this.hasUsedDates()) {
            this.rule.price = Number(this.rule.price);
            if (this.room.basePrices.length === 0
              || this.isNewPrice()) {
              if (this.filter.selected.length === 0 || this.filter.selected[0] === -1) {
                this.room.basePrices.push({
                  name: this.rule.name,
                  price: this.rule.price,
                  seasonIntervals: [
                    {
                      seasonFrom: this.rule.seasonFrom,
                      seasonTo: this.rule.seasonTo
                    }
                  ]
                });
              } else {
                const rule = {
                  name: this.rule.name,
                  price: this.rule.price,
                  seasonIntervals: []
                };
                this.addSeasonIntervals(rule);
                this.room.basePrices.push(rule);
              }
            } else {
              for (let i = 0; i < this.room.basePrices.length; i += 1) {
                const basePrice = this.room.basePrices[i];
                if (basePrice.price === this.rule.price) {
                  if (this.filter.selected.length === 0 || this.filter.selected[0] === -1) {
                    if (this.rule.name !== undefined
                      && this.rule.name !== null
                      && this.rule.name !== '') {
                      basePrice.name = this.rule.name;
                    }
                    basePrice.seasonIntervals.push({
                      seasonFrom: this.rule.seasonFrom,
                      seasonTo: this.rule.seasonTo
                    });
                  } else {
                    this.addSeasonIntervals(basePrice);
                  }
                  break;
                }
              }
            }
            this.rule = {
              name: undefined,
              price: undefined,
              seasonFrom: undefined,
              seasonTo: undefined
            };
            this.$refs.addBasePriceRule.reset();
            this.filter.selected = [-1];
            this.filter.changed = false;
          } else {
            this.error = true;
          }
        }
      },
      addSeasonIntervals(rule) {
        const days = this.$moment(this.rule.seasonTo).diff(this.$moment(this.rule.seasonFrom), 'days');
        let interval = {
          from: undefined,
          to: undefined
        };
        for (let i = 0; i <= days; i+= 1) {
          const day = this.$moment(this.rule.seasonFrom).add('day', i);
          if (interval.from === undefined) {
            if (this.containsWeekDay(day)) {
              interval.from = day.format('YYYY-MM-DD');
            }
          } else {
            if (this.containsWeekDay(day)) {
              interval.to = day.format('YYYY-MM-DD');
            } else {
              rule.seasonIntervals.push({
                seasonFrom: interval.from,
                seasonTo: interval.to === undefined ? interval.from : interval.to
              });
              interval = {
                from: undefined,
                to: undefined
              };
            }
          }
        }
        if (interval.from !== undefined) {
          rule.seasonIntervals.push({
            seasonFrom: interval.from,
            seasonTo: interval.to === undefined ? interval.from : interval.to
          });
        }
      },
      containsWeekDay(day) {
        for (let i = 0; i < this.filter.selected.length; i += 1) {
          const weekDay = this.filter.selected[i];
          if (weekDay === day.weekday()) {
            return true;
          }
        }
        return false;
      },
      isNewPrice() {
        let isNew = true;
        for (let i = 0; i < this.room.basePrices.length; i += 1) {
          const basePrice = this.room.basePrices[i];
          if (basePrice.price === this.rule.price) {
            isNew = false;
            break;
          }
        }
        return isNew;
      },
      deleteFromRules(ratePlan) {
        let index = -1;
        for (let i = 0; i < this.room.basePrices.length; i += 1) {
          const basePrice = this.room.basePrices[i];
          if (basePrice.price === ratePlan.price) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          this.room.basePrices.splice(index, 1);
        }
      },
      deleteInterval(index, basePrice) {
        if (basePrice.seasonIntervals.length === 1) {
          this.deleteFromRules(basePrice);
        } else {
          basePrice.seasonIntervals.splice(index, 1);
        }
      },
      getOtherBasePrices() {
        const basePrices = [];
        for (let i = 0; i < this.rooms.length; i += 1) {
          const casablancaHotelRoom = this.rooms[i];
          if (casablancaHotelRoom.basePrices.length > 0
            && casablancaHotelRoom.externalId !== this.room.externalId) {
            basePrices.push({
              name: casablancaHotelRoom.name,
              externalId: casablancaHotelRoom.externalId,
              maxOccupancy: casablancaHotelRoom.maxOccupancy,
              basePrices: casablancaHotelRoom.basePrices
            });
          }
        }
        return basePrices;
      },
      addBasePrices(room) {
        this.room.basePrices = JSON.parse(JSON.stringify(room.basePrices));
        for(let i = 0; i < this.room.basePrices.length; i += 1) {
          const casablancaBasePrice = this.room.basePrices[i];
          casablancaBasePrice.id = null;
          for (let j = 0; j < casablancaBasePrice.seasonIntervals.length; j += 1) {
            casablancaBasePrice.seasonIntervals[j].id = null;
          }
        }
      },
      allowedDates(val) {
        const date = this.$moment(val).endOf('day');
        for (let i = 0; i < this.room.basePrices.length; i += 1) {
          const basePrice = this.room.basePrices[i];
          for (let j = 0; j <  basePrice.seasonIntervals.length; j += 1) {
            const interval =  basePrice.seasonIntervals[j];
            if (this.$moment(interval.seasonFrom).endOf('day').isSameOrBefore(date)
              && this.$moment(interval.seasonTo).endOf('day').isSameOrAfter(date)) {
              return false;
            }
          }
        }
        return true;
      }
    }
  };
</script>

<style lang="scss">
  .base-price-table-container {
    .v-small-dialog__activator {
      display: inline-block;
    }
    .v-table {
      background-color: transparent;
    }
  }
  .add-base-price-container {
    .v-expansion-panel-header {
      padding-left: 0;
    }
    .v-expansion-panel::before {
      box-shadow: none;
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
    .v-expansion-panel__header {
      min-height: 30px;
      padding: 0;
    }
    .v-data-table td {
      font-size: 14px;
      height: 20px;
    }
  }
</style>
